 
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="caracteristiques.principales" 
 
[label]="step3.getprincipales"
[type]="'text'" [rule]="'minSize_5|maxSize_2000'"
[name]="getUid()+'_SepAtt_principales'">
</app-form-input>

<app-type-table-min-max  *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [tabCarMinMax]="caracteristiques.tabCarMinMax"></app-type-table-min-max>

<app-type-table-car1  *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [tabCar1]="caracteristiques.tabCar1"></app-type-table-car1>

<app-type-tableau-libre  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [tabCarLibre]="caracteristiques.tabCarLibre"></app-type-tableau-libre>

<app-type-oui-non [labelRadio]="step3.getspan3" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [typeOuiNon]="caracteristiques.variantes"></app-type-oui-non>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="caracteristiques.quantites" 
 
[label]="step3.getquantites"
[type]="'text'" [rule]="'minSize_5|maxSize_2000'"
[name]="getUid()+'_SepAtt_quantites'">
</app-form-input>